import AppComment from "./Comment";

export default AppComment;